import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  Alert,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import MBFLogo from '../../utilities/dummy_assets/MBF_Logo.png';
import MapITLogo from '../../utilities/dummy_assets/mapITlogo.png';
import postureImage from '../../utilities/dummy_assets/image24.png';
import sizeImage from '../../utilities/dummy_assets/image25.png';
import background from '../../utilities/dummy_assets/background.png';
import Logo from '../../utilities/dummy_assets/MBF_Logo.png';
import tinkerersLogo from '../../utilities/dummy_assets/tinkerersLogo.png';
import mapITlogo from '../../utilities/dummy_assets/mapITlogo.png';

const ResubmitInstruction = () => {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);
  const [showError, setShowError] = useState(false);

  const handleOpenCamera = () => {
    if (!isChecked) {
      setShowError(true);
      return;
    }
    setShowError(false);
    navigate('/profile-recapture');
  };

  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        padding: '1rem',
        boxSizing: 'border-box',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      {/* Top Left Logo */}
      {/* <Box sx={{ position: "absolute", top: 20, left: 20 }}>
        <img src={MBFLogo} alt="MBF Logo" style={{ maxWidth: "120px", height: "auto" }} />
      </Box> */}

      {/* Top Right Link */}
      <Box sx={{ position: 'absolute', top: 20, right: 20 }}>
        <Typography
          component="a"
          href="/student"
          sx={{
            textDecoration: 'underline',
            color: '#007BFF',
            fontWeight: 500,
            fontSize: '16px',
          }}
        >
          Go to student site
        </Typography>
      </Box>

      {/* Main Card */}
      <Box
        sx={{
          width: '100%',
          maxWidth: '520px',
          backgroundColor: '#FFFFFF',
          borderRadius: '24px',
          padding: '20px 20px',
          boxShadow: '4px 4px 20px rgba(0, 123, 255, 0.1)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px',
        }}
      >
        {/* Title */}
        <Typography
          variant="h6"
          fontWeight={600}
          color="#212121"
          align="center"
          sx={{ mb: 1 }}
        >
          Set Your Profile Photo
        </Typography>

        {/* Note */}
        <Box
          sx={{
            width: '100%',
            backgroundColor: '#FEFFD2',
            borderLeft: '4px solid #D0A300',
            borderRadius: '4px',
            padding: '10px 12px',
            textAlign: 'center',
          }}
        >
          <Typography fontSize="14px" fontWeight={500} color="#D0A300">
            Keep these things in mind while clicking your picture
          </Typography>
        </Box>

        {/* Posture Section */}
        <Box sx={{ width: '100%' }}>
          <Typography fontWeight={500} fontSize="16px" color="#3F3F3F" mb={1}>
            Posture:
          </Typography>
          <img
            src={postureImage}
            alt="Posture"
            style={{ width: '88%', borderRadius: '6px', objectFit: 'contain' }}
          />
        </Box>

        {/* Size Section */}
        <Box sx={{ width: '100%' }}>
          <Typography fontWeight={500} fontSize="16px" color="#3F3F3F" mb={1}>
            Size:
          </Typography>
          <img
            src={sizeImage}
            alt="Size"
            style={{ width: '88%', borderRadius: '6px', objectFit: 'contain' }}
          />
        </Box>

        {/* Checkbox Agreement */}
        <Box sx={{ width: '100%' }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isChecked}
                onChange={e => {
                  setIsChecked(e.target.checked);
                  if (e.target.checked) setShowError(false);
                }}
                sx={{
                  color: '#007BFF',
                  '&.Mui-checked': {
                    color: '#007BFF',
                  },
                }}
              />
            }
            label={
              <Typography
                sx={{ fontSize: '14px', color: '#3F3F3F', textAlign: 'start' }}
              >
                By using the MBF MIS, you consent to the processing of your
                contact information by Maker Bhavan Foundation for marketing &
                communication purposes. Please confirm that you and read and
                understood the instructions above
              </Typography>
            }
            sx={{
              alignItems: 'flex-start',
            }}
          />
        </Box>

        {/* Error Message */}
        {showError && (
          <Alert severity="error" sx={{ width: '100%' }}>
            Please confirm that you have read the instructions before
            proceeding.
          </Alert>
        )}

        {/* Buttons */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            mt: 2,
          }}
        >
          <Typography
            sx={{
              color: '#007BFF',
              fontWeight: 500,
              fontSize: '14px',
              cursor: 'pointer',
              alignSelf: 'center',
            }}
            onClick={() => navigate('/login')}
          >
            &lt; Back
          </Typography>

          <Button
            variant="contained"
            onClick={handleOpenCamera}
            sx={{
              backgroundColor: isChecked ? '#007BFF' : '#ccc',
              color: '#fff',
              fontWeight: 600,
              fontSize: '14px',
              padding: '10px 20px',
              borderRadius: '10px',
              textTransform: 'none',
              boxShadow: 'none',
              cursor: isChecked ? 'pointer' : 'not-allowed',
              '&:hover': {
                backgroundColor: isChecked ? '#B2D7FF' : '#ccc',
                boxShadow: 'none',
              },
            }}
          >
            Open Camera
          </Button>
        </Box>
      </Box>

      {/* Footer */}
      <Box
        sx={{
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center', // Adjust alignment to center
          p: '16px 24px',
          mt: 'auto', // Push the footer to the bottom
          gap: '1rem', // Add consistent spacing between elements
        }}
      >
        <img
          src={Logo}
          alt="MBF Logo"
          style={{ height: '60px', width: '150px' }}
        />
        <img
          src={tinkerersLogo}
          alt="mapIT Logo"
          style={{ height: '60px', width: '150px' }}
        />
        <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: '0.5rem' }}>
          <img
            src={mapITlogo}
            alt="mapIT Logo"
            style={{ height: '60px', width: '60px' }}
          />
          <Typography
            sx={{
              color: '#4b0282',
              fontFamily: "'Arial Black', 'Helvetica Neue', Arial, sans-serif",
              fontSize: '28px',
              fontWeight: 900,
              lineHeight: '1',
              letterSpacing: '-0.02rem',
              margin: 0,
              whiteSpace: 'nowrap',
              textTransform: 'none',
              fontStyle: 'normal',
              marginLeft: '-0.5rem',
            }}
          >
            apIT.ai
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ResubmitInstruction;
